import React, { Component } from "react";
import { View, Image, TouchableOpacity, Linking } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, walletStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor, yellowDarkColor, yellowLightColor } from "../theme/colors";
import { myRebateCodeRequest } from "../utils/api";
import Waiting from "../components/Waiting";

export default class CodeScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            code: '',
            count: '',
            text_share: '',
            message: '',
            waiting: true
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>کد معرف آد</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={walletStyles.wraper}>
                <View style={walletStyles.walletBox}>

                    <View style={[appStyles.boxWraper]}>
                        <TextView>کد آد شما</TextView>
                        <View style={componentStyles.roundInput}>
                            <TextView style={{ color: blueDarkColor, fontSize: 24 }}>{this.state.code}</TextView>
                        </View>
                        <TextView style={{ textAlign: 'center', marginLeft: 10, marginRight: 10 }}>{this.state.message}</TextView>
                        <TouchableOpacity style={{ alignSelf: 'center', margin: 20 }} activeOpacity={0.5} onPress={() => {

                            const shareData = {
                                title: 'اشتراک گذاری کد ',
                                text: this.state.text_share + '\n' + this.state.code,
                                url:'https://client.asandarman.ir/',
                            }

                            if(window.navigator.share)
                            {
                                navigator.share(shareData).then(response=>{

                                }).cancel(error=>{

                                })
                            }else {
                                Linking.openURL(`https://api.whatsapp.com/send?text=${this.state.text_share + '\n' + this.state.code}`);
                            }


                        }}>
                            <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[yellowLightColor, yellowDarkColor]} style={[componentStyles.gradinatButton, { width: 150, height: 50, borderRadius: 25 }]}>
                                <TextView style={{ color: 'white' }}>ارسال به دوستان</TextView>
                            </LinearGradient>
                        </TouchableOpacity>
                        <TextView>تا کنون {this.state.count} نفر از کد آد شما استفاده کردن</TextView>
                    </View>
                    <View style={walletStyles.diamondWraper}>
                        <Image source={icons['diamond']} style={[appStyles.toolbarIcon, { tintColor: blueDarkColor }]} />
                    </View>
                </View>
                <Waiting waiting={this.state.waiting} />
            </LinearGradient>
        </View>)
    }

    componentWillMount() {
        myRebateCodeRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    code: response.data.rebate_code,
                    count: response.data.all_number,
                    text_share: response.data.text_share,
                    message: response.data.about_rebate
                })
            }
        })
    }

}
